import { useLayerLookup } from '@app/modules/Risk/Profile/hooks/useLayerLookup'
import { ElementGroupBucket } from './useElementGroupBuckets'
import { useMemo } from 'react'

/**
 * Buckets element IDs into single-element buckets labelled by their layer name.
 * Use when displaying ungrouped elements.
 */
export const useElementBuckets = (elementIds: string[]): ElementGroupBucket[] => {
  const layerLookup = useLayerLookup()

  return useMemo(
    () =>
      elementIds.map((elementId) => ({
        [layerLookup.getTitle(elementId)]: [elementId],
      })),
    [elementIds, layerLookup],
  )
}
